import type { ConflictComponent, ConflictDetails, Vehicle } from 'src/app/api/owcc/models';

import type { FeasibilityResultAlternative } from './feasibility-result-alternative.interface';

/**
 * Sometimes a configuration has to be changed by our backend, this can be caused by
 * - a conflict
 * - a motorization transfer
 * - entering the configurator with an Onlinecode or Baumuster
 * For all cases we use the same Modal to show the user the additional changes
 * This enum is used to differentiate between the cases
 */
export enum AdditionalChangesInitiator {
  Conflict = 'CONFLICT',
  MotoTransfer = 'MOTOTRANSFER',
  OnlineCode = 'ONLINECODE',
  Healing = 'HEALING'
}

export interface FeasibilityResult {
  alternatives?: FeasibilityResultAlternative[];
  conflictItem?: ConflictComponent;
  conflictDetails?: ConflictDetails;
  vehicle?: Vehicle;
  changeInitiator: AdditionalChangesInitiator;
  selectedBaumusterNst?: string;
  fastSelect?: boolean;
}
